import { ACTION_SEQUENCE_ACTIONS } from '../../actions/sequences';

const initialState = {
  processing: false,
  results: [],
  actionSequence: undefined
};

const ActionSequencesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_SEQUENCE_ACTIONS.ACTION_SEQUENCE_STARTED: {
      return {
        ...state,
        processing: true,
        actionSequence: action.payload.actionSequence
      };
    }
    case ACTION_SEQUENCE_ACTIONS.ACTION_SEQUENCE_FINISHED: {
      return {
        ...state,
        processing: false,
        results: action.payload.results
      };
    }
    default:
      return state;
  }
};

export default ActionSequencesReducer;
